import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ActivatedRoute} from "@angular/router";
import {BaseView} from "../../../../../core/view/base.view";
import {DocumentFindOneByIdService} from "../../../../common/api/service/documentFindOneById.service";
import {DocumentModel} from "../../../../common/api/model/document.model";
import {LoadingModule} from "../../../../../../components/common/loading/loading.module";
import {ErrorCardModule} from "../../../../../../components/common/error-card/error-card.module";
import {DocumentDownloadService} from "../../../../common/api/service/documentDownload.service";
import {CardModule} from "../../../../../core/component/card/card.module";
import {PdfPreviewModule} from "../../../../../core/component/pdf-preview/pdf-preview.module";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MomentAdapter} from "../../../../../../shared/utils/moment.utils";
import {FormFieldModule} from "../../../../../core/component/form-field/form-field.module";
import {InputTextModule} from "../../../../../core/component/input-text/input-text.module";
import {EmailInputModule} from "../../../../../common/email/component/email-input/email-input.module";
import {DatePickerModule} from "../../../../../../components/common/date-picker/date-picker.module";
import {ButtonModule} from "../../../../../core/component/button/button.module";
import {
  SignatureInputComponent
} from "../../../../../common/signature/api/component/signature-input/signature-input.component";
import {MatFormFieldModule} from "@angular/material/form-field";
import {DocumentSignActionService} from "../../../../common/api/service/documentSignAction.service";
import {DateSummaryFieldModule} from "../../../../../core/component/date/date-summary-field/date-summary-field.module";
import {SummaryFieldModule} from "../../../../../core/component/summary-field/summary-field.module";
import {AuthService} from "../../../../../auth/api/service/auth.service";
import {Subscription} from "rxjs";
import {DialogController} from "../../../../../common/dialog/dialogController";
import {
  DocumentSignatureSendDialogComponent
} from "../document-signature-send-dialog/document-signature-send-dialog.component";
import {DocumentFindOneByPublicIdService} from "../../../../common/api/service/documentFindOneByPublicId.service";
import {DocumentTemplateFindOneByIdService} from "../../../../template/api/service/documentTemplateFindOneById.service";
import {DocumentTemplateModel} from "../../../../template/api/entity/documentTemplate.model";
import {
  DocumentTemplateGenerateFormComponent
} from "../../../../template/api/component/document-template-generate-form/document-template-generate-form.component";
import {DocumentTemplateSignService} from "../../../../template/api/service/documentTemplateSign.service";
import {DocumentDownloadModule} from "../../../../common/api/component/document-download/document-download.module";
import {DownloadButtonModule} from "../../../../../core/component/download-button/download-button.module";
import {CardV2Component} from "../../../../../core/component/card-v2/card-v2.component";

@Component({
  selector: 'app-document-sign',
  standalone: true,
  imports: [CommonModule, LoadingModule, ErrorCardModule, CardModule, PdfPreviewModule, FormFieldModule, InputTextModule, EmailInputModule, DatePickerModule, ButtonModule, SignatureInputComponent, MatFormFieldModule, DateSummaryFieldModule, SummaryFieldModule, DocumentTemplateGenerateFormComponent, DocumentDownloadModule, DownloadButtonModule, CardV2Component],
  templateUrl: './document-sign.component.html',
  providers: [
      DocumentFindOneByIdService,
      DocumentDownloadService,
      DocumentSignActionService,
      DocumentFindOneByPublicIdService,
      DocumentTemplateFindOneByIdService,
      DocumentTemplateSignService
  ],
})
export class DocumentSignComponent extends BaseView implements OnChanges {

  @ViewChild('sig') sigComp!: SignatureInputComponent;
  @Input() documentId: number;
  @Input() displaySignButton = true;
  @Input() displayDownloadButton = true;
  @Output() signedEvent: EventEmitter<void> = new EventEmitter<void>();

  id: number;
  publicId: string;
  document: DocumentModel;
  template: DocumentTemplateModel;
  pdf: Blob;
  error: any;
  formGroup: FormGroup;
  subscriptions: Subscription[] = [];
  constructor(private activatedRoute: ActivatedRoute,
              public documentFindOneByIdService: DocumentFindOneByIdService,
              public documentFindOneByPublicIdService: DocumentFindOneByPublicIdService,
              public documentDownloadService: DocumentDownloadService,
              public documentSignService: DocumentSignActionService,
              public documentTemplateSignService: DocumentTemplateSignService,
              public documentTemplateFindOneByIdService: DocumentTemplateFindOneByIdService,
              private formBuilder: FormBuilder,
              public authService: AuthService,
              private dialogController: DialogController) {
    super();
    this.formGroup = this.formBuilder.group({
      date: this.formBuilder.control(MomentAdapter.current().get(), Validators.required),
      name: this.formBuilder.control(undefined, Validators.required),
      email: this.formBuilder.control(undefined, Validators.required),
      signature: this.formBuilder.control(undefined, Validators.required),
    });

    this.subscriptions.push(this.authService.user.subscribe(value => {
      this.formGroup.get('date').disable();
      if (value) {
        this.formGroup.get('date').enable();
      }
    }))

    this.activatedRoute.paramMap.subscribe(params => {

      if (this.documentId) {
        return;
      }

      this.id = this.routeUtils.getValueAsNumber('id', params);
      if (this.id) {
        this.reloadDocument();
      } else {
        this.publicId = this.routeUtils.getValue('publicId', params);
        if (this.publicId) {
          this.reloadDocument();
        } else {
          this.redirectTo('404');
        }
      }

    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['documentId'] && this.documentId) {
      this.id = this.documentId;
      this.reloadDocument();
    }
  }

  signatureChanged(imgBase64:string) {
    this.formGroup.patchValue({
      signature: imgBase64
    });
  }

  sign() {
    if (this.template) {
      this.documentTemplateSignService.executeAction({
        partnerId: this.document.summary.partner?.id,
        facts: this.formGroup.value.facts,
        id: this.template.summary.id,
        placeHolders: this.formGroup.value.placeHolders,
        signature: {
          date: this.formGroup.value.date,
          email: this.formGroup.value.email,
          name: this.formGroup.value.name,
          signatureBase64: this.formGroup.value.signature,
          id: this.id,
          publicId: this.publicId
        }
      }).then((document) => {
        this.document = document;
        this.reloadDocument();
        this.toastControl.presentConfirmation("Votre signature a été enregistrée");
        this.signedEvent.emit();
      }).catch((err) => this.toastControl.presentError(err));
    } else {
      this.documentSignService.executeAction({
        date: this.formGroup.value.date,
        email: this.formGroup.value.email,
        name: this.formGroup.value.name,
        signatureBase64: this.formGroup.value.signature,
        id: this.id,
        publicId: this.publicId
      }).then((document) => {
        this.document = document;
        this.reloadDocument();
        this.toastControl.presentConfirmation("Votre signature a été enregistrée");
      }).catch((err) => this.toastControl.presentError(err));
    }
  }

  reloadDocument() {
    if (this.id) {
      this.documentFindOneByIdService.loadEntity(this.id)
          .then((result) => {
            this.document = result;
            this.patchDocument();
            this.loadDocumentContent();
            this.loadTemplate();
          })
          .catch((error) => this.error = error);
    } else if (this.publicId) {
      this.documentFindOneByPublicIdService.loadEntity(this.publicId)
          .then((result) => {
            this.document = result;
            this.patchDocument();
            this.loadDocumentContent();
            this.loadTemplate();
          }).catch((error) => this.error = error);
    }
  }

  loadTemplate() {
    if (! this.template && this.document?.summary?.templateId) {
      this.documentTemplateFindOneByIdService.loadEntity(this.document?.summary?.templateId)
          .then(result => this.template = result)
          .catch(error => this.error = error);
    }
  }

  patchDocument() {
    if (this.document.summary.partner) {
      this.formGroup.patchValue({
        name: this.document.summary.partner.name,
        email: this.document.summary.partner.email,
      })
    }
  }

  loadDocumentContent() {
    this.documentDownloadService.executeAction({
      id: this.document.summary.id
    }).then((downloadResult) => this.pdf = downloadResult)
        .catch(reason => this.error = reason);
  }

  download() {
    if (this.pdf) {
      const url = window.URL.createObjectURL(this.pdf);
      const a = document.createElement('a');
      a.href = url;
      a.download = this.document.summary.originalFilename;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }

  send() {
    this.dialogController.open(DocumentSignatureSendDialogComponent, this.document.summary, {
      title: 'Envoyer le lien pour la signature',
      width: '95%'
    });
  }
}
